<template>
  <Nav></Nav>
  <main class="new-project">
    <back-button></back-button>
    <ProjectEditor :edit="false" :orgSlug="orgSlug"></ProjectEditor>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BackButton from '@/components/BackButton.vue';
import Nav from '@/components/Nav.vue';
import ProjectEditor from '@/components/ProjectEditor.vue';

export default defineComponent({
  name: 'NewProject',
  components: {
    BackButton,
    Nav,
    ProjectEditor,
  },
  data  () {
    return {
      orgSlug: this.$route.params.org_slug as string,
    };
  },
});
</script>
